import { render } from "./FormsPage.vue?vue&type=template&id=141a6cec&ts=true"
import script from "./FormsPage.vue?vue&type=script&lang=ts"
export * from "./FormsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__